import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  margin-top: 0;
  transition: all 0.3s ease;
`;

export const SegmentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const SegmentCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
  align-self: start;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const SegmentCardContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SegmentTitle = styled.div`
  margin: 0;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const EmployeeBadge = styled.div`
  font-size: 12px;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  svg {
    color: #94a3b8;
    font-size: 14px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: auto;
  padding-top: 12px;
`;

export const UsageBadgesContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-shrink: 0;
`;

export const UsageBadge = styled.div`
  font-size: 11px;
  color: #475569;
  background-color: #f1f5f9;
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #e2e8f0;
  white-space: nowrap;

  svg {
    font-size: 14px;
    color: #64748b;
  }
`;

export const CreatedAtText = styled.div`
  font-size: 11px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;

  svg {
    font-size: 12px;
  }
`;
